/**
 * Servidores MCP — detail view for one server, reached by clicking its card
 * on McpServersListPage (or a sidebar shortcut). Thin route wrapper: the
 * actual status/catalog/guardrails/activity view lives in
 * McpServerDetailPanel, reused as-is.
 */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Empty, Spin } from 'antd';
import { ApiOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import AppPageLayout from './common/AppPageLayout';
import PageHeader from './common/PageHeader';
import McpServerDetailPanel from './organization/McpServerDetailPanel';
import { useAdminGuard } from '../hooks/useAdminGuard';
import { MCP_SERVERS } from '../types/mcp';

const McpServerDetailPage: React.FC = () => {
  const { loading } = useAdminGuard();
  const navigate = useNavigate();
  const { serverId } = useParams<{ serverId: string }>();
  const server = MCP_SERVERS.find((s) => s.id === serverId);

  if (loading) {
    return (
      <AppPageLayout>
        <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
          <Spin size="large" />
        </div>
      </AppPageLayout>
    );
  }

  const backButton = (
    <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/organization/mcp')}>
      Servidores MCP
    </Button>
  );

  if (!server) {
    return (
      <AppPageLayout>
        <PageHeader icon={<ApiOutlined />} title="Servidor no encontrado" action={backButton} />
        <Empty description={`No existe un servidor MCP con id "${serverId}"`} />
      </AppPageLayout>
    );
  }

  return (
    <AppPageLayout>
      <PageHeader
        icon={<ApiOutlined />}
        title={server.name}
        subtitle={server.description}
        action={backButton}
      />
      <McpServerDetailPanel serverId={server.id} />
    </AppPageLayout>
  );
};

export default McpServerDetailPage;
